import { useEffect, useState } from 'react';

export const useScrollY = () => {
  const [scrollY, setScrollY] = useState<number>(0);

  const listener = () => {
    setScrollY(window.scrollY);
  };

  useEffect(() => {
    window.addEventListener('scroll', listener);
    return () => {
      window.removeEventListener('scroll', listener);
    };
  });

  return {
    scrollY,
  };
};
